import forge from 'node-forge'
import base64 from 'base64url'
import reduce from 'lodash/reduce'
import includes from 'lodash/includes'
import isArray from 'lodash/isArray'
import isObject from 'lodash/isObject'

function arraybufferString (arraybuffer) {
  let str = ''
  for (let iii = 0; iii < arraybuffer.byteLength; iii++) { str += String.fromCharCode(arraybuffer[iii]) }
  return str
}

export function base64BigInt (b64) {
  return new forge.jsbn.BigInteger(
    forge.util.binary.hex.encode(
      base64decode(b64)
    ),
    16
  )
}

export function mergeMapAwait (list, map, keyName) {
  return Promise.all(list.map(map))
    .then(
      values =>
        list.map(
          (i, k) =>
            ({ ...i, [keyName]: values[k] })
        )
    )
}

export function bigintBase64 (bi) {
  return base64encode(
    arraybufferString(
      forge.util.binary.hex.decode(bi.toString(16))
    )
  )
}

export function base64encode (str) {
  return base64.encode(str)
}

export function base64decode (str) {
  return base64.decode(str)
}

export function findProps (propNames) {
  const find = (o, k) => includes(propNames, k)
    ? { [k]: o }
    : isArray(o)
    ? {}
    : isObject(o)
    ? reduce(o, (a, o, k) => ({ ...a, ...find(o, k) }), {})
    : {}

  return find
}
